import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Equipamiento, EquipamientoFiltro, PaginaEquipamiento } from "../../types/Equipamiento";

export const TAMANIO_PAGINA_INICIAL = 10;

export const equipamientoFiltroInitial: EquipamientoFiltro = {
    nombre: "",
    activo: "",
}

interface Paginacion {
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
}

interface EquipamientoState {
    equipamientoList: Equipamiento[];
    // Filtro aplicado en la última búsqueda; la paginación se pide siempre con este filtro.
    filtro: EquipamientoFiltro;
    paginacion: Paginacion;
    loading: boolean;
}

const initialState: EquipamientoState = {
    equipamientoList: [],
    filtro: equipamientoFiltroInitial,
    paginacion: { page: 0, size: TAMANIO_PAGINA_INICIAL, totalElements: 0, totalPages: 0 },
    loading: false,
}

const equipamientoSlice = createSlice({
    name: 'equipamiento',
    initialState,
    reducers: {
        isLoading: (state, data: PayloadAction<boolean>): void => {
            state.loading = data.payload;
        },
        loadPaginaEquipamiento: (state, data: PayloadAction<PaginaEquipamiento>): void => {
            state.equipamientoList = data.payload.content;
            state.paginacion = {
                page: data.payload.number,
                size: data.payload.size,
                totalElements: data.payload.totalElements,
                totalPages: data.payload.totalPages,
            };
        },
        loadDataFiltro: (state, data: PayloadAction<EquipamientoFiltro>): void => {
            state.filtro = data.payload;
        },
    }
});

export const {
    isLoading,
    loadPaginaEquipamiento,
    loadDataFiltro,
} = equipamientoSlice.actions;

export default equipamientoSlice.reducer;
